import {
    OrganizationType,
    UserMembershipInfo
} from '@slr/user-service-external-sdk';
import { isUserProfileRegistrationComplete } from './isUserProfileRegistrationComplete';

type UserLike = Parameters<typeof isUserProfileRegistrationComplete>[0];

export const userHasOwnUserOrganization = (
  memberships: UserMembershipInfo[] | null | undefined
): boolean =>
  memberships?.some(
    (membership) => membership.organizationType === OrganizationType.User
  ) ?? false;

export const userNeedsRegistrationStepTwo = (
  userProfile: UserLike,
  memberships: UserMembershipInfo[] | null | undefined
): boolean => {
  if (!isUserProfileRegistrationComplete(userProfile)) {
    return true;
  }

  if (userProfile?.billingAddress?.addressType !== 'business') {
    return false;
  }

  return !userHasOwnUserOrganization(memberships);
};
